import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer id="contact" className="bg-[#0A1628] text-white pt-12 md:pt-16 pb-6 md:pb-8">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-10 gap-8 md:gap-12 mb-8 md:mb-12">
          {/* Left - Logo & Social */}
          <div className="lg:col-span-4">
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/2733261fde4eb6ca5d5b92336d650a8a/b6352a008471ad7da159707c3313e87e.png" 
                alt="Expo Hood Cleaning Logo" 
                className="h-16 md:h-20 w-auto mb-4"
              />
              <p className="text-gray-400 text-[14px] md:text-[15px] leading-relaxed">
                Professional commercial hood cleaning services for restaurants and commercial kitchens across Indiana and Michigan. Keeping your kitchen safe, clean, and compliant.
              </p>
            </div>
            
            {/* Social Media */}
            <div className="flex items-center gap-3 md:gap-4">
              <a 
                href="https://www.facebook.com/profile.php?id=61571308832734" 
                target="_blank" 
                rel="nofollow noopener noreferrer"
                className="w-[52px] h-[52px] md:w-[60px] md:h-[60px] rounded-full bg-[#1E5BA8] flex items-center justify-center hover:bg-[#164a8f] transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-white text-2xl md:text-3xl"></i>
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="nofollow noopener noreferrer"
                className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-white text-lg md:text-xl"></i>
              </a>
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="nofollow noopener noreferrer"
                className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-white text-lg md:text-xl"></i>
              </a>
              <a 
                href="https://youtube.com" 
                target="_blank" 
                rel="nofollow noopener noreferrer"
                className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-youtube-fill text-white text-lg md:text-xl"></i>
              </a>
            </div>
          </div>

          {/* Middle - Contact */}
          <div className="lg:col-span-3">
            <h4 className="text-white text-[15px] md:text-[16px] font-bold mb-4 md:mb-6 uppercase tracking-wider">Contact</h4>
            <div className="space-y-3 md:space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center mt-1 flex-shrink-0">
                  <i className="ri-map-pin-line text-base md:text-lg text-[#1E5BA8]"></i>
                </div>
                <div>
                  <div className="text-gray-300 text-[13px] md:text-[14px]">Serving Indiana & Michigan</div>
                  <div className="text-gray-400 text-[12px] md:text-[13px]">Extended service to surrounding states</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-base md:text-lg text-[#1E5BA8]"></i>
                </div>
                <div className="flex flex-col gap-0.5">
                  <a href="tel:+15743299050" className="text-gray-300 text-[13px] md:text-[14px] hover:text-white transition-colors cursor-pointer">
                    (574) 329-9050
                  </a>
                  <a href="tel:+15746221711" className="text-gray-300 text-[13px] md:text-[14px] hover:text-white transition-colors cursor-pointer">
                    (574) 622-1711
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-base md:text-lg text-[#1E5BA8]"></i>
                </div>
                <a href="mailto:bbbstanley54@gmail.com" className="text-gray-300 text-[13px] md:text-[14px] hover:text-white transition-colors cursor-pointer break-all">
                  bbbstanley54@gmail.com
                </a>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-base md:text-lg text-[#1E5BA8]"></i>
                </div>
                <div className="text-gray-300 text-[13px] md:text-[14px]">24/7 Emergency Service</div>
              </div>
            </div>
          </div>

          {/* Right - Quick Links */}
          <div className="lg:col-span-3">
            <h4 className="text-white text-[15px] md:text-[16px] font-bold mb-4 md:mb-6 uppercase tracking-wider">Quick Links</h4>
            <div className="space-y-2 md:space-y-3">
              <a href="#home" className="block text-gray-300 text-[13px] md:text-[14px] hover:text-white hover:pl-2 transition-all cursor-pointer">
                Home
              </a>
              <a href="#services" className="block text-gray-300 text-[13px] md:text-[14px] hover:text-white hover:pl-2 transition-all cursor-pointer">
                Services
              </a>
              <a href="#service-area" className="block text-gray-300 text-[13px] md:text-[14px] hover:text-white hover:pl-2 transition-all cursor-pointer">
                Service Area
              </a>
              <a href="#about" className="block text-gray-300 text-[13px] md:text-[14px] hover:text-white hover:pl-2 transition-all cursor-pointer">
                About Us
              </a>
              <a href="#rewards" className="block text-gray-300 text-[13px] md:text-[14px] hover:text-white hover:pl-2 transition-all cursor-pointer">
                Rewards Program
              </a>
              <a href="#book-appointment" className="block text-[#1E5BA8] text-[13px] md:text-[14px] font-semibold hover:text-[#14B8A6] hover:pl-2 transition-all cursor-pointer">
                Book Appointment
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-6 md:pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-gray-400 text-[12px] md:text-[13px] text-center md:text-left">
              © 2025 Expo Hood Cleaning. All rights reserved.
            </div>
            <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
              <a href="#" className="text-gray-400 text-[12px] md:text-[13px] hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 text-[12px] md:text-[13px] hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Terms of Service
              </a>
              <a href="#" className="text-gray-400 text-[12px] md:text-[13px] hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Sitemap
              </a>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 text-[12px] md:text-[13px] hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
